import { View, Text, ScrollView } from "react-native";
import React from "react";
import Product from "./Product";
import ProductList from "./ProductList";
import { useStateContext } from "../lib/context";

const Collection = (props) => {
  const { productImages } = useStateContext();
  const ImageFinder = (sku) => productImages.get(sku) || "";
  console.log("estos son los produ", props.products);
  return (
    <ScrollView>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {props.products.map((item) => {
          if (props.type) {
            return (
              <ProductList
                key={item.sku}
                name={item.nombre}
                price={item.precio}
                sku={item.sku}
                Image={ImageFinder(item.sku)}
              />
            );
          } else {
            return (
              <Product
                key={item.sku}
                name={item.nombre}
                price={item.precio}
                sku={item.sku}
                Image={ImageFinder(item.sku)}
              />
            );
          }
        })}
      </View>
    </ScrollView>
  );
};

export default Collection;
